import Vue from 'vue'
import { login, logout } from '@/network/api/login'
import { changePassword, getAllRoles } from '@/network/api/user'
import { queryPermissionsByUser } from '@/network/api/api'
import { ACCESS_TOKEN, USER_NAME, USER_INFO, USER_AUTH, SYS_BUTTON_AUTH, UI_CACHE_DB_DICT_DATA, SET_ALLROLES } from '@/store/mutation-types'

const user = {
	state: {
		token: '',
		username: '',
		realname: '',
		welcome: '',
		avatar: '',
		permissionList: [],
		info: {},
		allRoles: [],
	},

	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_NAME: (state, { username, realname, welcome }) => {
			state.username = username
			state.realname = realname
			state.welcome = welcome
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_PERMISSIONLIST: (state, permissionList) => {
			state.permissionList = permissionList
		},
		SET_INFO: (state, info) => {
			state.info = info
		},
		SET_ALLROLES: (state, data) => {
			state.allRoles = data
		},
	},
	actions: {
		// 获取用户信息
		GetPermissionList({ commit }) {
			return new Promise((resolve, reject) => {
				const v_token = Vue.ls.get(ACCESS_TOKEN)
				const params = { token: v_token }

				console.log('params', params)
				queryPermissionsByUser(params)
					.then(response => {
						const menuData = response.result.menu
						const authData = response.result.auth
						const allAuthData = response.result.allAuth
						//Vue.ls.set(USER_AUTH,authData);
						sessionStorage.setItem(USER_AUTH, JSON.stringify(authData))
						sessionStorage.setItem(SYS_BUTTON_AUTH, JSON.stringify(allAuthData))
						if (menuData && menuData.length > 0) {
							//update--begin--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
							menuData.forEach((item, index) => {
								if (item['children']) {
									const hasChildrenMenu = item['children'].filter(i => {
										return !i.hidden || i.hidden == false
									})
									if (hasChildrenMenu == null || hasChildrenMenu.length == 0) {
										item['hidden'] = true
									}
								}
							})
							//console.log(' menu show json ', menuData)
							//update--end--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
							commit('SET_PERMISSIONLIST', menuData)
						} else {
							reject('getPermissionList: permissions must be a non-null array !')
						}
						resolve(response)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		/**
		 * 登录
		 * @param {*} param0
		 * @param {*} userInfo
		 */
		Login({ commit }, userInfo) {
			return new Promise((resolve, reject) => {
				var api_url = '/sys/login'
				if (userInfo.checkKey && userInfo.captcha) {
					api_url = '/sys/userLogin'
				}

				login(api_url, userInfo)
					.then(response => {
						console.log('登录结果Login', response)
						if (response.code == '200') {
							resolve(response)
						} else {
							reject(response)
						}
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		/**
		 * 登出
		 * @param {*} param0
		 */
		Logout({ commit, state }) {
			return new Promise(resolve => {
				console.log('登出')
				const logoutToken = state.token
				commit('SET_TOKEN', '')
				commit('SET_PERMISSIONLIST', [])
				Vue.ls.remove(ACCESS_TOKEN)
				Vue.ls.remove(UI_CACHE_DB_DICT_DATA)

				logout(logoutToken)
					.then(() => {
						resolve()
					})
					.catch(() => {
						resolve()
					})
			})
		},
		/**
		 * 修改密码。
		 * @param {*} param0
		 * @param {*} passwordInfo
		 */
		ChangePassowrd({ commit }, passwordInfo) {
			return new Promise((resolve, reject) => {
				changePassword(passwordInfo)
					.then(res => {
						//console.log(res)
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		/**
		 * 获取所有角色。
		 * @param {*} param0
		 */
		getAllRoles({ commit, state }) {
			getAllRoles()
				.then(res => {
					commit(SET_ALLROLES, res.result)
				})
				.catch(err => {
					reject(err)
				})
		},
	},
}

export default user
